import { render, staticRenderFns } from "./footprint.vue?vue&type=template&id=16d8ca03&scoped=true"
import script from "./footprint.vue?vue&type=script&lang=js"
export * from "./footprint.vue?vue&type=script&lang=js"
import style0 from "./footprint.vue?vue&type=style&index=0&id=16d8ca03&prod&lang=scss&scoped=true"
import style1 from "./footprint.vue?vue&type=style&index=1&id=16d8ca03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d8ca03",
  null
  
)

export default component.exports